import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ActivatedRoute, Router } from '@angular/router';

@Component( {
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.css']
} )
export class LogoutComponent implements OnInit {

    constructor( private cookieService: CookieService, private route: ActivatedRoute, private router: Router ) {
        this.logout();
    }

    ngOnInit() {
    }

    logout() {
        this.cookieService.deleteAll();
        // this.cookieService.delete('Token');
        // this.cookieService.delete('Provider');
        // this.cookieService.delete('userId');
        // this.cookieService.delete('username');
        // this.cookieService.delete('property_address');
        // this.cookieService.delete('assessment_context_id');
        // this.cookieService.delete('property_id');
        this.router.navigate( ['login'] );
    }

}
